export default __webpack_public_path__ + "static/premium-banner-img-mobile-min-703b9828164ba1cafff1cf4d0e0f607a.png";